import axios from "axios";

/**
 * Cliente HTTP con autenticación por cookies HttpOnly.
 *
 * Sprint 47 · interceptor global de 401 con `reason` estructurado:
 * cuando el backend devuelve `detail = { reason, detail }` (sesión
 * expirada por inactividad, revocada por nueva sesión, o cerrada
 * remotamente), lanzamos un CustomEvent `ct:session-terminated` para
 * que los stores hagan logout limpio con toast único.
 */
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  headers: { "Content-Type": "application/json" },
  timeout: 15000,
  withCredentials: true,
});

// Motivos que consideramos "sesión terminada del lado servidor" y por
// los que emitimos el evento global. Otros 401 (credenciales inválidas
// al login, tokens inválidos por manipulación) se dejan al llamador.
const SESSION_TERMINATED_REASONS = new Set([
  "INACTIVIDAD",
  "NUEVA_SESION",
  "ADMIN",
]);

let notifiedInFlight = false;

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const detail = error?.response?.data?.detail;
    if (status === 401 && detail && typeof detail === "object" && detail.reason) {
      if (SESSION_TERMINATED_REASONS.has(detail.reason) && !notifiedInFlight) {
        notifiedInFlight = true;
        try {
          window.dispatchEvent(
            new CustomEvent("ct:session-terminated", {
              detail: {
                reason: detail.reason,
                message: detail.detail || "Sesión finalizada",
              },
            })
          );
        } catch {
          /* ignore */
        }
        // Reset flag después de un tick para permitir futuras notifs
        setTimeout(() => {
          notifiedInFlight = false;
        }, 1500);
      }
    }
    return Promise.reject(error);
  }
);

export const getHealth = async () => {
  const { data } = await api.get("/health");
  return data;
};
